import { createContext, useContext } from 'react';

interface PatternStudioSiderContextValue {
    isCollapsed: boolean;
    setIsCollapsed: (value: boolean) => void;
}

export const PatternStudioSiderContext =
    createContext<PatternStudioSiderContextValue | null>(null);

export const usePatternStudioSider = () => {
    const context = useContext(PatternStudioSiderContext);

    if (!context) {
        throw new Error(
            'usePatternStudioSider must be used within PatternStudioSiderContext.Provider',
        );
    }

    return context;
};
